import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import { hasPermission } from "../utils/auth";

const RequirePermission = ({ permission, element }) => {
  const { isAuthenticated, initializing, user } = useAuth();
  if (initializing) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasPermission(user?.permissions, permission)) {
    return <Navigate to="/notFoundPage" replace />;
  }
  return element;
};

export default RequirePermission;
